// import { "apexSvg", "cftSvg", sgdsSvg, shipHatsSvg, techBizSvg, techPassSvg, containerStackSvg } from "../assets/svg-ts/products";

export const products = [
  {
    name: "API Exchange (APEX)",
    url: "",
    uniqueKey: "apex",
    svgUrl: "apex",
  },
  {
    // svgUrl: <GCCSvg/>,
    name: "GCC",
    url: "",
    uniqueKey: "gcc",
    svgUrl: "cft",
  },
  {
    // svg: <WogaaSvg/>,
    name: "WOGAA",
    url: "",
    uniqueKey: "wogaa",
    svgUrl: "apex",
  },
  {
    name: "Cloud File Transfer",
    url: "",
    uniqueKey: "cft",
    svgUrl: "cft",
  },
  {
    // svg: <SingpassSvg/>,
    name: "Singpass",
    url: "https://www.singpass.gov.sg/",
    uniqueKey: "singpass",
    svgUrl: "apex",
  },
  {
    name: "TechBiz",
    url: "",
    uniqueKey: "tech-biz",
    svgUrl: "tech",
  },
  {
    name: "Container Stack",
    url: "",
    uniqueKey: "container-stack",
    svgUrl: "containerStackSvg",
  },
  {
    name: "Singapore Government Design System",
    url: "https://www.designsystem.tech.gov.sg/",
    uniqueKey: "sgds",
    svgUrl: "sgdsSvg",
  },
  {
    name: "Techpass",
    url: "",
    uniqueKey: "techpass",
    svgUrl: "techPassSvg",
  },
  {
    // svg: <CorppassSvg/>,
    name: "Corppass",
    url: "",
    uniqueKey: "corppass",
    svgUrl: "apexSvg",
  },
  {
    name: "SHIP-HATS",
    url: "",
    uniqueKey: "ship-hats",
    svgUrl: "shipHatsSvg",
  },
];
